import React from 'react';
import ChatCore from './ChatCore';
import Icon from '../Icon';

export default function ChatWindow({ open, mode, isBrain, onClose }) {
  const title = isBrain ? 'Synoti Brain' : 'Synoti Assistant';
  const gradient = mode === 'admin'
    ? 'linear-gradient(135deg, #6366f1, #8b5cf6)'
    : 'linear-gradient(135deg, #10b981, #14b8a6)';
  const fullPageHash = isBrain ? 'rag-chat' : 'assistant';

  return (
    <div
      aria-hidden={!open}
      className={`transition-all duration-300 ease-out origin-bottom-right ${open ? 'opacity-100 scale-100 translate-y-0' : 'opacity-0 scale-95 translate-y-2 pointer-events-none'}`}
      style={{ position: 'absolute', bottom: 72, right: 0, width: 380, maxWidth: 'calc(100vw - 32px)', height: 520, maxHeight: 'calc(100vh - 120px)', display: 'flex', flexDirection: 'column', background: 'var(--surface)', border: '1px solid var(--glass-border)', borderRadius: 20, overflow: 'hidden', boxShadow: '0 24px 60px rgba(0,0,0,0.45)' }}
    >
      <div className="flex items-center gap-2" style={{ padding: '12px 16px', background: 'var(--glass)', borderBottom: '1px solid var(--glass-border)', flexShrink: 0 }}>
        <div style={{ width: 30, height: 30, borderRadius: 9, display: 'flex', alignItems: 'center', justifyContent: 'center', background: gradient, flexShrink: 0 }}>
          <Icon name="message-square" size={16} style={{ color: '#fff' }} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--text-1)' }}>{title}</div>
          <div className="muted" style={{ fontSize: 11 }}>
            {mode === 'admin' ? 'Knowledge base + live system state' : 'System status & basic guidance'}
          </div>
        </div>
        <button
          onClick={() => { window.location.hash = fullPageHash; }}
          title="Open full page"
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-3)', display: 'flex', alignItems: 'center', padding: 6, borderRadius: 8 }}
        >
          <Icon name="arrow-up-right" size={16} />
        </button>
        <button
          onClick={onClose}
          title="Close"
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-3)', display: 'flex', alignItems: 'center', padding: 6, borderRadius: 8 }}
        >
          <Icon name="circle-x" size={16} />
        </button>
      </div>
      <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', padding: 12 }}>
        <ChatCore mode={mode} isBrain={isBrain} compact />
      </div>
    </div>
  );
}
